import styled from 'styled-components';
import * as colors from '../../common/colorConstants';

export const AdminTools = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
  background-color: ${colors.baseBackground};
  width: 100%;
`;

export const Divider = styled.div`
  position: relative;
  min-height: 25px;
  border-bottom: 1px solid ${colors.lightGray21};
`;

export const CollapsibleSection = styled.div`
  width: 100%;
  border-bottom: 1px solid ${colors.lightGray21};
  padding-bottom: 20px;
  margin-bottom: 20px;

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 16px;
  }
`;

export const CollapsibleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 4px 0;
  cursor: pointer;
  margin-bottom: 12px;

  span {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 11px;
    line-height: 1.45;
    color: ${colors.darkGray1};
  }

  img {
    width: 8px;
    height: 4px;
  }
`;

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  margin-right: auto;
  min-width: 125px;
  height: 25px;
`;

export const PaginationLabel = styled.span`
  padding: 0 5px;
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  color: ${colors.darkGray1};
`;

export const PaginationButton = styled.span`
  cursor: pointer;
  top: -2px !important;

  &:before {
    color: #e1e6f2;
    font-size: 10px;
  }
`;
